var map = {
	"./Applications.mock.ts": "1b89",
	"./Carousels.mock.ts": "0ffa",
	"./Costs.mock.ts": "6792",
	"./DashBoard.mock.ts": "8113",
	"./DepartmentTree.mock.ts": "ccbd",
	"./DeviceInfo.mock.ts": "f808",
	"./Logs.mock.ts": "a39c",
	"./MemberAudit.mock.ts": "eaca",
	"./Safety.mock.ts": "699f",
	"./TeamJoined.mock.ts": "fe26",
	"./VDMock/VDList.mock.ts": "87c0",
	"./VDMock/VDLock.mock.ts": "b033",
	"./VDMock/VDTop.mock.ts": "5434",
	"./VDMock/VDUsed.mock.ts": "7628",
	"./VDMock/VDgroups.mock.ts": "5626",
	"./VisitList.mock.ts": "e0d9",
	"./formsMock/bindformedit.mock.ts": "0c85",
	"./grid.mock.ts": "45fd",
	"./groups.mock.ts": "de37",
	"./paymentmocks/PaymentCalculate.mock.ts": "2c81",
	"./paymentmocks/paymentCoins.mock.ts": "9753",
	"./paymentmocks/paymentCoupon.mock.ts": "fd53",
	"./shops.mock.ts": "0d1b",
	"./subAccount.mock.ts": "a13d",
	"./team.mock.ts": "4a38"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c26c";